import {
    getReadableTextClass,
    isValidHexColor,
    normalizeHexColor,
} from "./teamRoleColorUtils";
import { getRoleLabel } from "../../constants/roles";

export default function TeamRoleBadge({ name, colorHex, className = "" }) {
    const displayName = getRoleLabel(name).trim();
    const normalizedColor = normalizeHexColor(colorHex);
    const hasValidColor = isValidHexColor(normalizedColor);

    return (
        <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 font-medium ${
                hasValidColor
                    ? getReadableTextClass(normalizedColor)
                    : "bg-white text-slate-600 ring-1 ring-slate-200"
            } ${className}`}
            style={
                hasValidColor
                    ? { backgroundColor: normalizedColor }
                    : undefined
            }
            title={displayName}
        >
            {displayName}
        </span>
    );
}
